import { render, staticRenderFns } from "./GroupEditor.vue?vue&type=template&id=60de6fae&scoped=true&"
import script from "./GroupEditor.vue?vue&type=script&lang=ts&"
export * from "./GroupEditor.vue?vue&type=script&lang=ts&"
import style0 from "./GroupEditor.vue?vue&type=style&index=0&id=60de6fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de6fae",
  null
  
)

export default component.exports